/**
 * The B2C AI viewer is a separate SPA; a trace is addressed only by the hash
 * segment at the end of its visualization URL (e.g.
 * `https://pro-stage.amlbot.com/visualizer/abc123` -> `abc123`). Strip any
 * query/hash and trailing slash first so trailing junk never leaks in.
 */
const getVisualizationHash = (visualizationUrl: string): string => {
  const withoutQuery = visualizationUrl.split(/[?#]/, 1)[0];
  const segments = withoutQuery.split('/').filter(Boolean);
  return segments[segments.length - 1] || '';
};

/**
 * Build the B2C AI viewer URL for a trace. `lng` is one of `en | ua | ru`.
 * The viewer origin is configured via VITE_REACT_APP_AI_VIEWER_URL (no
 * trailing slash) and is never served in the cabinet's dev environment, so the
 * resulting frame is only ever asserted on, never read.
 */
const buildAiViewerUrl = (visualizationUrl: string, lng: string): string => {
  const base = (import.meta.env.VITE_REACT_APP_AI_VIEWER_URL || '').replace(
    /\/+$/,
    '',
  );
  // No viewer origin configured: return '' so the page renders no frame at
  // all instead of framing the cabinet inside itself.
  if (!base) {
    return '';
  }
  const hash = encodeURIComponent(getVisualizationHash(visualizationUrl));
  return `${base}/${hash}?lng=${lng}`;
};

export { buildAiViewerUrl, getVisualizationHash };
